import type {ReactNode} from 'react';

import {PortableLink} from '@/modules/foundation/components/portable-text/portable-link';

import type {LinkFragment} from '../../link/query';
import {linkFragmentToHref} from '../../link/query';

type Props = {
	children: ReactNode;
	value: LinkFragment;
	className?: string;
};

export const PortableLinkContainer = ({children, value, className}: Props) => {
	return (
		<PortableLink
			href={linkFragmentToHref(value)}
			targetBlank={value?.targetBlank}
			className={className}
		>
			{children}
		</PortableLink>
	);
};
